import styles from "./Fleet.module.css"


const PopUpSummary = ({ param, searchControl, popUpControls, handleDates, formatDate, currentDateSelection, weekOffset, internalLoading, summaryLogs, indPopUpControls, allFleet, setActiveSummary, activeSummary }) => {
	return (
		<div className={styles.popup_container_six}>
			<button className={styles.closePopup} onClick={() => popUpControls('summary')}><i class="fa-solid fa-x"></i></button>

			<h1 className={styles.medium_font}>Refuel summary</h1>
			<p className={styles.smaller_font}>View a summary of fleet refuels week to week.</p>

			<div className={styles.sites_tablecontainer_auto}>
				<div className={`${styles.sites_controls} ${styles.indsite_controls_wh}`}>
					<div className={`${styles.currDateSel}`}>
						<button disabled={internalLoading} onClick={() => handleDates('prev')}><i className="fa-solid fa-angle-left"></i></button>
						<p>{formatDate(currentDateSelection[0], false)} - {formatDate(currentDateSelection[1], false)}</p>
						<button disabled={internalLoading} onClick={() => handleDates('next')}><i className="fa-solid fa-angle-right"></i></button>
					</div>
				</div>

				<div className={styles.box_layout}>
    				{["Refuel", "Drive"].map((item) => {
    					return (
			    			<button onClick={() => setActiveSummary(item)} className={`${styles.site_status} ${activeSummary === item ? styles.box_active : styles.status_active}`}>
			    				<p className={styles.smaller_font}>{item}</p>
			    			</button>
				    	)
				    })}
				</div>

				<div className={`${styles.sites_controls} ${styles.indsite_controls_wh} ${styles.extra_margin_bottom}`}>
					<div className={`${styles.sites_searchcontainer} ${styles.autowidth}`}>
						<div className={styles.sites_search}>
							<i className="fa-solid fa-magnifying-glass"></i>
							<input
							    type="text"
							    className={styles.smaller_font}
							    placeholder="Search for any of the column headings..."
							    onKeyUp={(event) => searchControl(event, "ind_table")}
							/>
						</div>
					</div>
				</div>

				{internalLoading
					?
						<div className={styles.loadpage_container}>
							<div className={styles.load}>
								<span></span>
								<span></span>
								<span></span>
								<span></span>
							</div>
						</div>
					:
						<div className={styles.table_container}>
							<table className={styles.sites_table} id="ind_table">
							    <thead className={styles.sitesind_thead}>
							    	{activeSummary === "Refuel"
							    		?
											<tr className={`${styles.table_rowth} ${styles.tr_only}`}>
												<th colspan="2" className={styles.small_font}>Date</th>
												<th colspan="1" className={styles.small_font}>Rego</th>
												<th colspan="1" className={styles.small_font}>Amount</th>
												<th colspan="1" className={styles.small_font}>Price</th>
												<th colspan="1" className={styles.small_font}>Driver</th>
											</tr>
										:
											<tr className={`${styles.table_rowth} ${styles.tr_only}`}>
												<th colspan="2" className={styles.small_font}>Date</th>
												<th colspan="1" className={styles.small_font}>Rego</th>
												<th colspan="1" className={styles.small_font}>Start mileage</th>
												<th colspan="1" className={styles.small_font}>End mileage</th>
												<th colspan="1" className={styles.small_font}>Total mileage</th>
												<th colspan="1" className={styles.small_font}>Driver</th>
											</tr>
							    	}
							    </thead>
							    <tbody className={styles.indtbody_cus}>

						            {summaryLogs.length > 0 ? (
						                <>
						                    {summaryLogs.map((FL) => {
						                    	let fleetFound = allFleet.find(f => f._id.toString() === FL.vehicle_id.toString())
						                    	
						                    	return (
							                    	<>
							                    		{FL.logs.map((RL) => {
									                    	return (
									                    		<>
															    	{activeSummary === "Refuel"
															    		?
													                        <tr className={styles.sitesind_tr} onClick={() => indPopUpControls('open', fleetFound)}>
													                        	<td colSpan="2">{formatDate(RL.date_refueled, true, false)}</td>
													                            <td colSpan="1">{FL.vehicle_rego}</td>
													                            <td colSpan="1">{RL.amount_refueled}L</td>
													                            <td colSpan="1">${RL.price}</td>
													                            <td colSpan="1">{RL.driver}</td>
													                        </tr>
																		:
													                        <tr className={styles.sitesind_tr} onClick={() => indPopUpControls('open', fleetFound)}>
													                        	<td colSpan="2">{formatDate(RL.date_drove, true, false)}</td>
													                            <td colSpan="1">{FL.vehicle_rego}</td>
													                            <td colSpan="1">{RL.start_mileage}km</td>
													                            <td colSpan="1">{RL.end_mileage}km</td>
													                            <td colSpan="1">{RL.end_mileage - RL.start_mileage}km</td>
													                            <td colSpan="1">{RL.driver}</td>
													                        </tr>
															    	}
															    </>
									                        )
							                    		})}
							                    	</>
								                )
						                   	})}
						                </>
						            ) : (
						                <h1 className={`${styles.medium_font} ${styles.create_first2}`}>There are no logs yet!</h1>
						            )}

							    </tbody>
							</table>
						</div>
				}
			</div>
		</div>
	)
}

export default PopUpSummary;